<th class="product-image" [ngClass]="{'disabled': isDisabled}">
  <div *ngIf="isVariationProduct" class="product-variations-warning font-5 color--alert">Products with variations cannot be edited in list view. Please switch to grid view if edits are needed.</div>
  <div *ngIf="isItemCut" class="product-variations-warning font-5 color--alert">{{ 'This item has been cut' }}</div>
  <div class="product-image-cell font-5" >
    <div class="image-container font-5">
      <app-image-container
        [image]="imageUrl"
        type="small-product"
        featurePosition='featured-bottom'
        class="clickable"
        [recommended]="isProductRecommended"
        [featured]="product.isFeatured"
        (click)="onImageClicked()"></app-image-container>
    </div>
    <div class="">
      <div class="font-6 font-weight-normal">
        <app-product-item-number [itemNumber]="product.skus[0].getDisplaySkuID()"
                                 [supplierId]="product.skus[0].supplierId"></app-product-item-number>
      </div>
      <div class="">
        <span class="text-capitalize font-weight-bold" [innerHTML]="product.label | safeContent "></span>
        <app-product-order-item-price [orderItem]="_orderItem" [product]="product"
                                      position="relative"
                                      viewType="grid-item" fontSize="font-5">
        </app-product-order-item-price>

      </div>
    </div>

  </div>

</th>
<th class="product-details" [ngClass]="{'disabled': isDisabled}">
  <div class="product-details-cell">
    <app-product-recommened-quantity *ngIf="isProductRecommended" view="grid"
                                     [recommendedQty]="product.recommended_qty_expected" [currentQty]="product.recommended_qty_current"
    ></app-product-recommened-quantity>
    <!--min order-->
    <app-product-order-item-min-max class="mt-2" *ngIf="showMinOrder"
                                    [orderItem]="_orderItem"
                                    [showGroupedMaxQuantity]="true"
                                    [headerPosition]="true"
                                    [isRecommended]="isProductRecommended"
                                    [product]="product" viewType="grid-item" fontSize="font-6">
    </app-product-order-item-min-max>
    <app-on-demand-min-max class="mt-2"
                           [orderItem]="orderItem"
                           [product]="product" viewType="grid-item" fontSize="font-6">
    </app-on-demand-min-max>

    <!--in stock-->
    <app-product-order-item-in-stock
      *ngIf="!product.isBuyingWindow"
      [showCombinedQuantity] = "product.hasVariations"
      [sku]="variationSKU"
      [product]="product" [quantity]="orderedQuantity"
      fontSize="font-6" viewType="grid-item"></app-product-order-item-in-stock>

    <div class="collapsible-wrapper">
      <button class="btn btn-icon collapsible" [disabled]="isItemCut" (click)="toggleCollapsed()"><i class="fal " [ngClass]="{'fa-plus': isCollapsed, 'fa-minus': !isCollapsed }"></i></button>
    </div>
  </div>

</th>

<ng-container *ngIf="isEmptyAddressList; else withAddressList">
  <td class="delivery" [ngClass]="{'disabled': isDisabled}">
    <div class="delivery--cell">
      <input class="qty-input m-0"
             min="0"  digitOnly type="number"
             [value]="0"
             [disabled]="true"
      />
    </div>
  </td>
</ng-container>

<th class="product-subtotal" [ngClass]="{'disabled': isDisabled}">
  <div *ngIf='_orderItem' class="order-item__subtotal">
    <div class="d-flex align-items-center pl-4">
      <label class="label m-0">Items:&nbsp;</label>
      <span class="font-weight-bold m-0">{{ _orderItem.quantity }}</span>
    </div>
    <div class="d-flex align-items-center pl-4">
      <label class="label m-0">Total:&nbsp;</label>
      <span class="font-weight-bold price"><app-currency-price [price]="_orderItem.totalCost" [currency]="orderItemCurrency" [isItemCut]="isItemCut"></app-currency-price></span>
    </div>
    <div *ngIf="canOrder" class="text-center mt-2">
      <button
              [disabled]="!canPurchase || orderItemUpdating || isItemCut"
              (click)="saveWithDelay()"
              ngbTooltip="{{disabledTooltip}}"
              type="button"
              class="btn btn-primary btn-purchase" [ngClass]="{'value-changed': _orderItem.changed}">
        <i *ngIf="orderItemUpdating" class="fal fa-sync rotate mr-2"></i>
        <span>{{_orderItem.id ? 'Update': 'Add To Cart'}}</span>
      </button>
    </div>

  </div>

</th>


<ng-template #withAddressList>
  <ng-container *ngIf="_orderItem?.deliveries?.length; else emptyDeliveryCell">
    <td *ngFor="let delivery of _orderItem.deliveries" class="delivery" [ngClass]="{'disabled': isDisabled}">
      <div class="delivery--cell" >
        <app-product-list-item-input  [orderType]="orderType" [orderItem]="_orderItem"
                                      [originalOrderItem]="_originalOrderItem" [delivery]="delivery"
                                      [collapsed]="isCollapsed"
                                      (changed)="onDeliveryChanged()"
        ></app-product-list-item-input>
      </div>
    </td>
  </ng-container>
</ng-template>

<ng-template #emptyDeliveryCell>
  <td *ngFor="let address of _addressList" class="delivery" [ngClass]="{'disabled': isDisabled}">
    <div class="delivery--cell">&nbsp;</div>
  </td>
</ng-template>

